

module.exports = __webpack_require__.stylable.create(
    "horizontalmenusubitem2325253242",
    {"classes":{"root":"horizontalmenusubitem2325253242__root","positionBox":"horizontalmenusubitem2325253242__positionBox","opened":"horizontalmenusubitem2325253242__opened","collapsed":"horizontalmenusubitem2325253242__collapsed","expanded":"horizontalmenusubitem2325253242__expanded","expand-left":"horizontalmenusubitem2325253242__expand-left","expand-right":"horizontalmenusubitem2325253242__expand-right","container":"horizontalmenusubitem2325253242__container","label":"horizontalmenusubitem2325253242__label"},"vars":{},"stVars":{},"keyframes":{"expandLeftTranslate":"horizontalmenusubitem2325253242__expandLeftTranslate","expandRightTranslate":"horizontalmenusubitem2325253242__expandRightTranslate"}},
    "",
    1,
    112,
    null
);
